module.exports = __webpack_public_path__ + "static/site-ee1d57b5d1d979b17cffa7c7c2d76162.png";